var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{attrs:{"app":""}},[_c('div',{staticClass:"d-flex flex-column flex-grow-1 h-full w-full akn-content"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.$auth.ready())?_c('router-view'):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }